<script setup lang="ts">
import { useAuthUser, useGlobals } from '@/helpers/globals'
import { TgLogo } from '@/helpers/images'
import type { Mitteilung } from '@/models/Mitteilung'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { logout } from '@/helpers/auth'
import UserMenu from '@/components/user-menu-btn.vue'
import NeueMitteilungenBtn from '@/components/mitteilung/neue-mitteilungen-btn.vue'
import type { TeamMitglied } from '@/models/TeamMitglied'
import { useDisplay } from 'vuetify'

const {
    // app= false,
    teamrequests = [],
    mitteilungen = [],
} = defineProps<{
    teamrequests: TeamMitglied[]
    mitteilungen?: Mitteilung[]
}>()

const tab = ref(null)
const router = useRouter()
const route = useRoute()

function onMitteilungclick(mitteilung: Mitteilung) {
    if (mitteilung && mitteilung.gesuch_nummer) {
        router.push(`/gesuche/${mitteilung.gesuch_nummer}/nachrichten`).catch(() => {})
    }
}

const emit = defineEmits<{
    (e: 'show_help'): void
}>()

const benutzer = useAuthUser()
const env = useGlobals()?.config?.env
const { mdAndUp } = useDisplay()
</script>

<template>
    <v-app-bar
        color="white"
        :class="env || ''"
        class="tg-horizonte"
        scroll-behavior="elevate"
        scroll-threshold="1"
        extension-height="123"
        height="60"
    >
        <template v-slot:extension>
            <div class="extension-container kp-large-container">
                <div class="extension-top-row">
                    <img :src="TgLogo" height="45" alt="Thurgau-Logo" class="ml-2 mr-3 mb-5" />
                    <div>
                        <NeueMitteilungenBtn
                            v-if="mitteilungen && mitteilungen.length > 0"
                            @mitteilungclick="onMitteilungclick"
                        />
                        <v-btn v-if="mdAndUp" text @click="emit('show_help')">
                            <span class="d-none d-md-inline">
                                {{ $t('hilfe_kontakt') }}
                            </span>
                        </v-btn>
                        <v-btn v-else icon="fa-solid fa-square-question" @click="emit('show_help')" >
                        </v-btn>
                        <UserMenu
                            :benutzer="benutzer"
                            @logout="logout"
                            @profil="
                                route.path != '/adressen/profil'
                                    ? router.push('/adressen/profil')
                                    : () => {}
                            "
                        />
                    </div>
                </div>
                <div class="extension-second-row">
                    <v-tabs v-model="tab" stacked color="primary" show-arrows>
                        <v-tab class="pa-2" :to="{ name: 'home' }">
                            <v-icon dense>fas fa-home fa-xs</v-icon>
                            {{ $t('home') }}
                        </v-tab>
                        <v-tab class="pa-2" :to="{ name: 'gesuche' }">
                            <v-icon dense>fas fa-balance-scale fa-fw</v-icon>
                            {{ $t('gesuche') }}
                        </v-tab>
                        <v-tab class="pa-2" :to="{ name: 'adressen' }">
                            <v-icon>fas fa-address-book fa-fw</v-icon>
                            {{ $t('adressen') }}
                        </v-tab>
                        <v-tab class="pa-2" :to="{ name: 'liegenschaften' }">
                            <v-icon>fas fa-building fa-fw</v-icon>
                            {{ $t('liegenschaften') }}
                        </v-tab>
                        <v-tab class="pa-2" :to="{ name: 'teams' }">
                            <v-badge
                                v-if="teamrequests ? teamrequests.length : 0"
                                location="top right"
                                :content="teamrequests ? teamrequests.length : 0"
                                color="error"
                            >
                                <v-icon>fas fa-users fa-fw</v-icon>
                            </v-badge>
                            <v-icon v-else>fas fa-users fa-fw</v-icon>
                            {{ $t('teams') }}
                        </v-tab>
                        <v-tab
                            class="pa-2"
                            v-if="benutzer?.rolle === 'admin'"
                            :to="{ name: 'news' }"
                        >
                            <v-icon>fas fa-rss fa-fw</v-icon>
                            {{ $t('news') }}
                        </v-tab>
                        <v-tab
                            class="pa-2"
                            v-if="benutzer?.rolle === 'admin'"
                            :to="{ name: 'hilfetexte' }"
                        >
                            <v-icon>fas fa-circle-question fa-fw</v-icon>
                            {{ $t('hilfetexte') }}
                        </v-tab>
                    </v-tabs>
                </div>
            </div>
        </template>
    </v-app-bar>
</template>

<style lang="scss" scoped>
.tg-horizonte {
    background-image: url(@/resources/horizont.png);
    background-repeat: repeat-x;
    // background-size: 27px;
}
.extension-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    .extension-top-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: nowrap;
    }
    .extension-second-row {
        display: flex;
        justify-content: space-between;
        .v-tabs {
            --v-tabs-height: 100% !important;
        }
    }
}
</style>
